<button
  pButton
  [rounded]="true"
  [icon]="topic.icon"
  [label]="topic.title"
  (click)="openTopic()"></button>
